module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.size
  }, [_c('div', {
    class: _vm.classNames
  }, [(_vm.show_buttons) ? _c('a', {
    staticClass: "ui icon minus label",
    on: {
      "click": _vm.minus_clicked
    }
  }, [_c('i', {
    staticClass: "small fitted minus icon"
  })]) : _vm._e(), _vm._v(" "), _c('input', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.validate),
      expression: "validate"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.val),
      expression: "val"
    }],
    attrs: {
      "step": parseFloat(_vm.step),
      "id": _vm._uid,
      "name": _vm.name,
      "placeholder": _vm.placeholder,
      "max": _vm.max,
      "type": "number"
    },
    domProps: {
      "value": (_vm.val)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.val = $event.target.value
      }, function($event) {
        return _vm.$emit('input', $event.target.value)
      }]
    }
  }), _vm._v(" "), (_vm.icon) ? _c('i', {
    class: _vm.icon
  }) : _vm._e(), _vm._v(" "), (_vm.show_buttons) ? _c('a', {
    staticClass: "ui icon plus label",
    on: {
      "click": _vm.plus_clicked
    }
  }, [_c('i', {
    staticClass: "small fitted plus icon"
  })]) : _vm._e(), _vm._v(" "), (_vm.label) ? _c('div', {
    staticClass: "ui basic label"
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.errors.first(_vm.name)) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errors.first(_vm.name)))]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-375f66e1","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/InputNumber.vue
// module id = 491
// module chunks = 1